import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { EMPTY, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { KeyValue } from '@angular/common';
import { IView } from 'app/modules/shared-area/ducks/panel/models/IView';
import * as DossierActions from '../../store/dossier.actions';
import { getNamedViewsKeyValue } from 'app/modules/shared-area/ducks/panel/store/panel.selectors';
import { IAppState } from 'app/modules/shared-area/root-state';
import { ITriggerOnClose } from 'app/core/services/custom-window-service/custom-window.service';

@Component({
  selector: 'app-view-settings-dialog',
  templateUrl: './view-settings-dialog.component.html',
  styleUrls: ['./view-settings-dialog.component.scss']
})
export class ViewSettingsDialogComponent implements OnInit, OnDestroy, ITriggerOnClose {
  public namedViewsKeyValue$: Observable<KeyValue<string, { view: IView }>[]> = EMPTY;
  public closeWindow: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  private destroy$ = new Subject<void>();

  constructor(private store: Store<IAppState>) {}

  ngOnInit(): void {
    this.namedViewsKeyValue$ = this.store.pipe(
      select(getNamedViewsKeyValue),
      takeUntil(this.destroy$)
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public cancel(): void {
    this.closeWindow.emit(false);
  }

  public deleteView(viewName: string): void {
    this.store.dispatch(DossierActions.openDeleteViewConfirmDialog({ viewName }));
  }
}
